import React from 'react';
import { Link } from 'react-router-dom';
import NavigationLinks from '../components/NavigationLinks';

export default function Capture() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20 font-sans">
      <NavigationLinks />
      
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-slate-900">🎙️ Modality Capture</h1>
        <p className="text-slate-500 mt-2">Record and upload new diagnostic data</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
        <div className="bg-white rounded-xl border border-slate-200 p-8 text-center hover:shadow-md transition">
          <div className="text-5xl mb-4">🎙️</div>
          <h3 className="font-semibold text-slate-800">Acoustic Recording</h3>
          <p className="text-sm text-slate-500 mt-2">Capture cough/breath sounds</p>
          <button className="mt-4 px-6 py-2 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700">
            Start Recording
          </button>
        </div>
        
        <div className="bg-white rounded-xl border border-slate-200 p-8 text-center hover:shadow-md transition">
          <div className="text-5xl mb-4">🩻</div>
          <h3 className="font-semibold text-slate-800">Image Upload</h3>
          <p className="text-sm text-slate-500 mt-2">Upload X-ray or CT scans</p>
          <button className="mt-4 px-6 py-2 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700">
            Upload Image
          </button>
        </div>
      </div>
      
      <Link to="/insights" className="inline-block mt-8 text-indigo-600 hover:text-indigo-800">
        ← Back to Insights
      </Link>
    </div>
  );
}
